module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/camera.965e5e8d.svg";